import themeGet from "@styled-system/theme-get";
import { css } from "styled-components";

/** Base layout for a sidebar list row: padded, rounded, and laid out as a
 * horizontal flex with space between its children. Shared by
 * AIDashboardsContent's DashboardListItem and TeamCanvasContent's view rows,
 * which each add their own hover/active styling on top of it. */
export const sidebarRowLayout = css`
  padding: ${themeGet("space.s")};
  border-radius: ${themeGet("radii.2")};
  transition: ${themeGet("transition.transitionDefault")};
  align-items: center;
  justify-content: space-between;
  gap: ${themeGet("space.xs")};
`;
